import EmbeddedBuild from './EmbeddedBuild';

export default EmbeddedBuild;
